<div class="screen-element text-screen">
	<div class="title" [ngClass]="{'darkTitle':hasParameter('darkTitle'),'darkerTitle':hasParameter('darkerTitle')}">{{getTitle()}}</div>
<!--	<div class="dashboard-center">
		<div *ngIf="value" class="value">{{value}}</div>
		<div *ngIf="unit" class="unit">{{unit}}</div>
		<div *ngIf="dashIcon" class="icon {{dashIcon}}"></div>
	</div>-->
	<div class="text text-1">{{getText(0)}}</div>
	<div class="text text-2">{{getText(1)}}</div>
	<div class="text text-3">{{getText(2)}}</div>
	<div class="text text-4">{{getText(3)}}</div>
	<div class="text text-5">{{getText(4)}}</div>
</div>